import { makeStyles, fade } from '@material-ui/core/styles';

const styles = makeStyles(theme => {
  const stylesByStatus = props => {
    switch (props.status) {
      // pending
      case 'PENDING':
        return {
          color: theme.palette.custom.feedback.warning,
          background: fade(theme.palette.custom.feedback.warning, 0.08),
          backgroundHover: fade(theme.palette.custom.feedback.warning, 0.16),
          link: theme.palette.custom.feedback.warning,
        };
      // rejected
      case 'REJECTED':
        return {
          color: theme.palette.custom.feedback.negative,
          background: fade(theme.palette.custom.feedback.negative, 0.08),
          backgroundHover: fade(theme.palette.custom.feedback.negative, 0.16),
          link: theme.palette.custom.feedback.negative,
        };
      case 'APPROVED':
      default:
        return {
          color: theme.palette.text.hint,
          background: theme.palette.custom.surface[1],
          backgroundHover: theme.palette.custom.surface[2],
          link: theme.palette.primary.main,
        };
    }
  };

  return {
    container: {
      display: 'flex',
      marginBottom: theme.spacing(1),
      cursor: 'pointer',
      textAlign: 'left',

      '&.padded': {
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
      },

      '& .comment': {
        '&-avatar': {
          minWidth: theme.spacing(4),
          minHeight: theme.spacing(4),
          borderRadius: '50%',
          backgroundColor: props => stylesByStatus(props).background,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          alignSelf: 'flex-start',
          marginRight: theme.spacing(1),

          '&-icon': {
            color: props => stylesByStatus(props).color,
          },
        },
        '&-content': {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        },
        '&-ballon': {
          backgroundColor: props => stylesByStatus(props).background,
          borderRadius: theme.shape.borderRadiusLarge,
          borderTopLeftRadius: '0px',
          transition: theme.transitions.create(),
          padding: theme.spacing(2),
          position: 'relative',

          '& .comment-actions-container': {
            opacity: 0,
          },

          '&-title': {
            display: 'flex',
            color: props => stylesByStatus(props).color,
            fontWeight: theme.typography.fontWeightMedium,

            '&.not-link': {
              '&:hover': {
                textDecoration: 'none !important',
              },
            },
          },
          '&-date': {
            display: 'flex',
            marginTop: theme.spacing(1 / 2),
            color: props => stylesByStatus(props).color,
          },
          '&-msg': {
            margin: theme.spacing(1, 0, 0, 0),
            color: theme.palette.text.secondary,
            wordBreak: 'break-word',

            '&.cropped': {
              maxHeight: 60,
              overflow: 'hidden',
            },
          },
          '&-view-more': {
            color: props => stylesByStatus(props).link,
            marginTop: theme.spacing(1),
          },
        },
        '&-actions': {
          '&-container': {
            position: 'absolute',
            top: theme.spacing(1),
            right: theme.spacing(1),
          },
        },
        '&-footer': {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: theme.spacing(1 / 2),
          marginBottom: theme.spacing(1),

          '&-btn-container': {
            marginRight: theme.spacing(1),
          },

          '&-btn-responses, &-btn-reply': {
            ...theme.typography.caption,
            textTransform: 'none',
          },

          '&-btn-responses': {
            '&.active': {
              color: theme.palette.primary.main,
            },
          },

          '&-date': {
            marginLeft: 'auto',
            color: theme.palette.text.hint,
          },

          '&-info': {
            display: 'flex',
            alignItems: 'center',

            '&-icon': {
              marginRight: theme.spacing(1),
            },
            '&-text': {
              lineHeight: 1,
            },
            '&.pending': {
              color: theme.palette.custom.feedback.warning,
            },
            '&.rejected': {
              color: theme.palette.custom.feedback.negative,
            },
          },
        },
      },

      '&.is-focused, &:hover': {
        '& .comment': {
          '&-ballon': {
            backgroundColor: props => stylesByStatus(props).backgroundHover,
            '& .comment-actions-container': {
              opacity: 1,
            },
          },
        },
      },

      '&:not(.is-focused)': {
        '& .comment-footer-date': {
          display: 'none',
        },
      },
    },
  };
});

export default styles;
